
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/declaracao-de-imposto-de-renda-2022",
      function () {
        return require("private-next-pages/blog/declaracao-de-imposto-de-renda-2022.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/declaracao-de-imposto-de-renda-2022"])
      });
    }
  